import React from 'react';
import PropTypes from 'prop-types';
import ReactPannellum from 'react-pannellum';
import { trans } from '@spotahome/soyuz/client';

import './Viewer360.scss';

const BASE_CONFIG = {
  autoLoad: true,
  autoRotate: -3,
  mouseZoom: false,
  autoRotateInactivityDelay: 2000,
  doubleClickZoom: true
};

const Viewer360 = ({ id, src, config }) => {
  const activeConfig = Object.assign({}, BASE_CONFIG, config);

  return (
    <ReactPannellum
      id={id}
      sceneId={id}
      imageSource={src}
      config={activeConfig}
      style={{
        width: '100%',
        height: '100%',
        background: '#000000'
      }}
      uiText={{
        loadingLabel: `${trans('loading')}...`,
        loadButtonLabel: trans('viewer.360.click.load.message')
      }}
    />
  );
};

Viewer360.propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  config: PropTypes.object
};

Viewer360.defaultProps = {
  config: BASE_CONFIG
};

export default Viewer360;
